import { render, staticRenderFns } from "./brewInfo.vue?vue&type=template&id=7c34fc2a&"
import script from "./brewInfo.vue?vue&type=script&lang=js&"
export * from "./brewInfo.vue?vue&type=script&lang=js&"
import style0 from "./brewInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports